import './App.css';

function App() {
  return (
    <div className="container">
      <aside className="sidebar"></aside>
      <main className="main-content">
        <header className="header">
          <h1 className="primal-title">PRIMAL</h1>
        </header>
        <div className="content">
          <div className="status-indicator">
            <span className="status-dot"></span>
            <span className="status-text">Module Online</span>
          </div>
          <h2 className="module-title">PARTNERS</h2>
          <p className="module-description">Advertising Portal</p>
          <div className="placeholder">
            <p>Ready to connect to Supabase</p>
            <p className="config-hint">Configure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env</p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
